import React, { Component } from "react";
import { withRouter } from "react-router-dom";
import { connect } from "react-redux";
import { addProductsToList } from "../../Redux/slices/productQuery";
import { GET_PRODUCTS } from "../../apollo";
import { client } from "../../../App";

const mapStateToProps = state => {
    return {
        currentQuery: state.productQuery.currentQuery
    }
}

const mapDispatchToProps = dispatch => {
    return {
        addProducts: payload => dispatch(addProductsToList(payload))
    }
}

class LoadMore extends Component {
    constructor(props) {
        super(props);
        this.fetch = this.fetch.bind(this);
        this.fetchOnScroll = this.fetchOnScroll.bind(this);

        this.state = {
            inlineFetching: false
        }
    }

    fetch() {
        this.setState({ inlineFetching: true });

        console.log(this.props.productCount)
        
        const first = (this.props.productCount + this.props.perPage) - 6;

        client.query({
            query: GET_PRODUCTS,
            variables: {
                ...this.props.queryVars,
                after: this.props.currentQuery.lastEdge,
                // first: this.props.perPage
                first
            }
        }).then(resp => {
            // this.props.addProducts({
            //     products: resp.data.products.nodes,
            //     lastEdge: resp.data.products.edges[resp.data.products.edges.length - 1].cursor
            // });
            this.props.addProducts({
                products: resp.data.products.nodes
            })
            this.setState({ inlineFetching: false });
        }).catch(error => {
            console.error(error);
        });
    }

    fetchOnScroll() {
        var productList = this.props.currentQuery;
        var relProgress = productList.count.fetched / productList.count.total;

        if (productList.count.total === 0 && ((this.props.currentQuery.count.fetched - 6) / this.props.perPage) % 1 === 0) {
            relProgress = 0.1;
        }

        if (this.state.inlineFetching === false && relProgress < 1) {
            var scrollPos = window.scrollY + window.innerHeight;
            var bodyHeight = document.getElementsByTagName("body")[0].offsetHeight;
            
            if (scrollPos + 400 > bodyHeight) {
                this.fetch();
            }
        }
    }

    componentDidMount() {
        this.fetch();
        window.addEventListener("scroll", this.fetchOnScroll);
    }

    componentWillUnmount() {
        window.removeEventListener("scroll", this.fetchOnScroll);
    }

    render() {
        var productList = this.props.currentQuery;

        if (!productList) {
            return null;
        }
        
        var relProgress = (productList.count.fetched - 6) / productList.count.total;
        var progressWidth = relProgress * 100 + "%";

        // If category does not have a total count (e.g. category === 0) = Set relProgress to 0.1 if fetched results are even to perPage
        var displayProgress = true;
        if (productList.count.total < 1) {
            displayProgress = false;
            
            if (((this.props.currentQuery.count.fetched - 6) / this.props.perPage) % 1 === 0) {
                relProgress = 0.1;
            }
        }

        var loadMoreBtn;
        if (relProgress < 1 && this.state.inlineFetching === true) {
            loadMoreBtn = <div className="vv-loading-spinner">
                <div className="loader"></div>
            </div>;
        }
        
        return <div className="load-more-wrap">
            {loadMoreBtn}

            { displayProgress && 
                <div className="display-progress">
                    <div className="progress-bar-wrap">
                        <div className="progress-bar" style={{
                            width: (productList.count.fetched / productList.count.total * 100) + "%"
                        }}></div>
                    </div>

                    <span className="progress-text">Showing {productList.count.fetched} of {productList.count.total} products</span>
                </div>
            }
        </div>
    }
}

export default withRouter(connect(mapStateToProps, mapDispatchToProps)(LoadMore));